import { NavLink, Outlet, Link, useLocation, Navigate } from "react-router-dom";
import { LayoutDashboard, Users, ShoppingCart, Settings, ExternalLink } from "lucide-react";
import { useParentAuth } from "@/context/ParentAuthContext";

const nav = [
  { to: "/parent", end: true, label: "Overview", icon: LayoutDashboard, tid: "parent-nav-overview" },
  { to: "/parent/cubers", label: "My Cubers", icon: Users, tid: "parent-nav-cubers" },
  { to: "/parent/register", label: "Register", icon: ShoppingCart, tid: "parent-nav-register" },
  { to: "/parent/settings", label: "Settings", icon: Settings, tid: "parent-nav-settings" },
];

export default function ParentLayout() {
  const { parent, loading } = useParentAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-[40vh] grid place-items-center text-[#7A7D8C]" data-testid="parent-session-loading">Checking your session…</div>;
  if (!parent) return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-8 md:py-10" data-testid="parent-portal-layout">
      <div className="flex items-center justify-between gap-3 mb-5">
        <span className="text-xs font-bold uppercase tracking-wider text-[#B36906]">Parent Portal</span>
        <Link to="/" data-testid="parent-back-to-site" className="flex items-center gap-1 text-xs text-[#7A7D8C] hover:text-[#FF9F1C]"><ExternalLink className="w-3.5 h-3.5" />Back to website</Link>
      </div>
      <nav aria-label="Parent Portal" className="flex flex-wrap gap-2 border-b border-slate-200 pb-5 mb-8">
        {nav.map((item) => { const Icon = item.icon; return <NavLink key={item.to} to={item.to} end={item.end} data-testid={item.tid} className={({ isActive }) => `inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold transition-colors ${isActive ? "bg-[#FF9F1C] text-white" : "bg-white border border-slate-200 hover:bg-[#FFBF69]/15"}`}><Icon className="w-4 h-4" />{item.label}</NavLink>; })}
      </nav>
      <Outlet />
    </div>
  );
}
